// Splits message text into text/link parts for rendering. Trailing punctuation is
// NOT part of a URL: trainer replies wrap product links in parentheses and end
// sentences with them — "(https://chewy.sjv.io/qzRkMq)," must link the URL alone,
// not a 404 with ")," glued on.
export interface LinkifyPart {
  type: 'text' | 'link';
  value: string;
}

const URL_RE = /(https?:\/\/[^\s]+)/g;
const isUrl = (s: string) => /^https?:\/\//.test(s);
// Characters that read as surrounding punctuation when they END a match.
const TRAILING_PUNCT_RE = /[).,;:!?\]'"”’]+$/;

export function linkifyParts(text: string): LinkifyPart[] {
  const parts: LinkifyPart[] = [];
  const push = (type: LinkifyPart['type'], value: string) => {
    if (!value) return;
    const last = parts[parts.length - 1];
    if (last && last.type === 'text' && type === 'text') last.value += value;
    else parts.push({ type, value });
  };
  String(text).split(URL_RE).forEach((piece) => {
    if (!isUrl(piece)) {
      push('text', piece);
      return;
    }
    const trailing = piece.match(TRAILING_PUNCT_RE)?.[0] ?? '';
    push('link', trailing ? piece.slice(0, -trailing.length) : piece);
    push('text', trailing);
  });
  return parts;
}
